import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/dataportActions';
import DataportsCommandRow from './DataportsCommandRow';

const DataportsCommandsTable = ({dataportIds, technicalDataportsFetched, actions}) => {
  const {getDataportsTechnical} = actions;
  useEffect(() => {
    if (technicalDataportsFetched === false) {
      getDataportsTechnical();
    }
  }, []);

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Code</th>
          <th>Output</th>
        </tr>
      </thead>
      <tbody>
        {dataportIds.map(dataportId => <DataportsCommandRow key={dataportId} id={dataportId}/>)}
      </tbody>
    </table>
  );
};

DataportsCommandsTable.propTypes = {
  dataportIds: PropTypes.array.isRequired,
  technicalDataportsFetched: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const {selectedDpIds, technicalDataportsFetched} = state.dataportReducer;
  return {
    dataportIds: selectedDpIds,
    technicalDataportsFetched,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataportsCommandsTable);
